<mat-card class="flex-col flex">
    <mat-card-header>
        <div mat-card-avatar class="cb-card-avatar-icon mat-mdc-header-card-avatar">
            @if (mappedItem?.qualifiedDate || canQualify()) {
                <mat-icon class="cb-primary" title="Complete"> check_circle </mat-icon>
            }
            @if (!mappedItem?.qualifiedDate && !canQualify()) {
                <mat-icon class="cb-error" title="Incomplete"> error </mat-icon>
            }
        </div>
        <mat-card-title [ngClass]="!mappedItem?.stepFinanceInfoComplete ? 'cb-error' : ''">
            {{ stepNumber }}. Qualify
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="start-start flex-col flex cb-margin-bottom-2x">
        <span class="mat-body-2">
            Once these steps have been completed the Lead can be qualified to start the Create
            Process
        </span>
        <ul>
            @if (mappedItem.contacts.length > 0) {
                <li class="start-center flex-row">
                    <mat-icon class="mat-primary">check_circle</mat-icon>
                    &nbsp;Client Details Specified
                </li>
            }
            @if (mappedItem.contacts.length < 1) {
                <li class="cb-error start-center flex-row">
                    <mat-icon class="cb-error">error</mat-icon>
                    &nbsp;Client Details to be Specified
                </li>
            }
            @if (lotDetailsEntered()) {
                <li class="start-center flex-row">
                    <mat-icon class="mat-primary">check_circle</mat-icon>
                    &nbsp;Lot Details Entered
                </li>
            }
            @if (mappedItem.contractType == LOT_CONTRACT_TYPE_ENUM.None) {
                <li class="cb-error start-center flex-row">
                    <mat-icon class="cb-error">error</mat-icon>
                    &nbsp;Choose a Contract Type
                </li>
            }
            @if (primaryLotHasClientSale()) {
                <li class="cb-error start-center flex-row">
                    <mat-icon class="cb-error">error</mat-icon>
                    <span style="margin-left: 4px">
                        Primary Lot Interest already has a Client Sale - add or set another
                        available Lot as the Primary Lot Interest
                    </span>
                </li>
            }
            @if (
                mappedItem.contractType != LOT_CONTRACT_TYPE_ENUM.None &&
                !lotDetailsEntered() &&
                !primaryLotHasClientSale()
            ) {
                <li class="cb-error start-center flex-row">
                    <mat-icon class="cb-error">error</mat-icon>
                    &nbsp;Lot Details to be Entered
                </li>
            }
            @if (
                numberOfHouseAndLandInterests() < 1 &&
                mappedItem.contractType == LOT_CONTRACT_TYPE_ENUM.HouseAndLand
            ) {
                <li class="cb-error start-center flex-row">
                    <mat-icon class="cb-error">error</mat-icon>
                    &nbsp;Lot Interests to be Entered
                </li>
            }
            @if (
                numberOfDesignAndLandInterests() < 1 &&
                mappedItem.contractType == LOT_CONTRACT_TYPE_ENUM.DesignAndLand
            ) {
                <li class="cb-error start-center flex-row">
                    <mat-icon class="cb-error">error</mat-icon>
                    &nbsp;Lot Interests to be Entered
                </li>
            }
            @if (mappedItem.stepEnquiryOriginComplete) {
                <li class="start-center flex-row">
                    <mat-icon class="mat-primary">check_circle</mat-icon>
                    &nbsp;Enquiry Origin Entered
                </li>
            }
            @if (!mappedItem.stepEnquiryOriginComplete) {
                <li class="cb-error start-center flex-row">
                    <mat-icon class="cb-error">error</mat-icon>
                    &nbsp;Enquiry Origin to be Entered
                </li>
            }
            @if (mappedItem.stepFinanceInfoComplete) {
                <li class="start-center flex-row">
                    <mat-icon class="mat-primary">check_circle</mat-icon>
                    &nbsp;Finance Informaton Entered
                </li>
            }
            @if (!mappedItem.stepFinanceInfoComplete) {
                <li class="cb-error start-center flex-row">
                    <mat-icon class="cb-error">error</mat-icon>
                    &nbsp;Budget Needs To Be Entered
                </li>
            }
            @if (mappedItem.qualifiedDate) {
                <li class="cb-margin-top-3x" class="mat-body-2 start-center flex-row">
                    <mat-icon>info</mat-icon>
                    &nbsp; This Lead is Qualified
                </li>
            }
        </ul>
    </mat-card-content>
    @if ((canSeeMarkAsLost() || canSeeQualify()) && canEdit && !mappedItem.isQualified()) {
        <div>
            <mat-divider class="card-divider"></mat-divider>
        </div>
    }
    @if ((canSeeMarkAsLost() || canSeeQualify()) && canEdit && !mappedItem.isQualified()) {
        <mat-card-actions class="end-center flex-row layoutGap-16">
            @if (canSeeMarkAsLost()) {
                <button
                    mat-stroked-button
                    color="warn"
                    [disabled]="!canMarkAsLost()"
                    (cbClick)="markAsLost()"
                >
                    <mat-icon>cancel</mat-icon>
                    &nbsp;Lost
                </button>
            }
            @if (canSeeQualify() && !mappedItem.isQualified()) {
                <button
                    mat-raised-button
                    color="primary"
                    [disabled]="!canQualify()"
                    (cbClick)="qualifyLead()"
                    style="margin-right: 0"
                >
                    <mat-icon>check_circle</mat-icon>
                    &nbsp;Qualify
                </button>
            }
        </mat-card-actions>
    }
</mat-card>
